import React, { useReducer } from 'react';
import firebase from "firebase/app";
import 'firebase/auth';

import { getFirebaseApp } from 'config/firebase/client';
import { firestoreInitialize } from 'config/firebase/client';

import UsersReducer from './UsersReducer';
import UsersContext from './UsersContext';

const UsersState = (props) => {
    const initialState = {
        getUsers: {
            users: [],
            firstUser: null,
            lastUser: null,
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
        getUsersById: {
            user: null,
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
        createUser: {
            user: {
                firstName: null,
                lastName: null,
                email: null,
                status: null,
                role: null,
                userIsCreated: null,
            },
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            },
        },
        updateUsersById: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        updateUserPassword: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        },
        updateUserAvatar: {
            loading: false,
            hasSuccess: false,
            hasError: {
                code: null,
                message: null
            }
        }
    }

    const [state, dispatch] = useReducer(UsersReducer, initialState);

    const getUsers = (nextPage, prevPage, country) => {
        dispatch({ type: 'GET_USERS_LOADING' });

        if (country) {
            getUsersPerCountry(nextPage, prevPage, country);
        } else {
            getGlobalUsers(nextPage, prevPage);
        }
    };

    const getGlobalUsers = (nextPage, prevPage) => {
        let db = firestoreInitialize();
    
        if (nextPage) {
            db.collection('Administradores')
                .where('authId', '==', nextPage)
                .get()
                .then((querySnapshot) => {
                    const dataAfter = querySnapshot.docs[0];

                    let first = db.collection("Administradores")
                    .orderBy('authId')
                    .startAfter(dataAfter)
                    .limit(10)
    
                    first.get().then((documentSnapshots) => {
                        dispatch({ type: 'GET_USERS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                    })
                    .catch(error => dispatch({ type: 'GET_USERS_ERROR', payload: { code: 'users/error', message: error } }))   
            })
            .catch((error) => dispatch({ type: 'GET_USERS_ERROR', payload: { code: 'users/error', message: error } }))
        } else if (prevPage) {
            db.collection('Administradores')
            .where('authId', '==', prevPage)
            .get()
            .then((querySnapshot) => {
                const dataBefore = querySnapshot.docs[0];

                let first = db.collection("Administradores")
                .orderBy('authId')
                .endBefore(dataBefore)
                .limitToLast(10);

                first.get().then((documentSnapshots) => {
                    dispatch({ type: 'GET_USERS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                })
                .catch(error => dispatch({ type: 'GET_USERS_ERROR', payload: { code: 'users/error', message: error } }))   
            })
            .catch((error) => dispatch({ type: 'GET_USERS_ERROR', payload: { code: 'users/error', message: error } }))
        } else {
            let first = db.collection("Administradores")
                .limit(10)

            first.get().then((documentSnapshots) => {
                dispatch({ type: 'GET_USERS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
            })
            .catch(error => dispatch({ type: 'GET_USERS_ERROR', payload: { code: 'users/error', message: error } }))   
        }
    }

    const getUsersPerCountry = (nextPage, prevPage, country) => {
        let db = firestoreInitialize();
    
        if (nextPage) {
            db.collection('Administradores')
                .where('authId', '==', nextPage)
                .get()
                .then((querySnapshot) => {
                    const dataAfter = querySnapshot.docs[0];

                    let first = db.collection("Administradores")
                    .where("pais", "==", country)
                    .orderBy('authId')
                    .startAfter(dataAfter)
                    .limit(10)
    
                    first.get().then((documentSnapshots) => {
                        dispatch({ type: 'GET_USERS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                    })
                    .catch(error => dispatch({ type: 'GET_USERS_ERROR', payload: { code: 'users/error', message: error } }))   
            })
            .catch((error) => dispatch({ type: 'GET_USERS_ERROR', payload: { code: 'users/error', message: error } }))
        } else if (prevPage) {
            db.collection('Administradores')
            .where('authId', '==', prevPage)
            .get()
            .then((querySnapshot) => {
                const dataBefore = querySnapshot.docs[0];

                let first = db.collection("Administradores")
                .where("pais", "==", country)
                .orderBy('authId')
                .endBefore(dataBefore)
                .limitToLast(10);

                first.get().then((documentSnapshots) => {
                    dispatch({ type: 'GET_USERS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
                })
                .catch(error => dispatch({ type: 'GET_USERS_ERROR', payload: { code: 'users/error', message: error } }))   
            })
            .catch((error) => dispatch({ type: 'GET_USERS_ERROR', payload: { code: 'users/error', message: error } }))
        } else {
            let first = db.collection("Administradores")
                .where("pais", "==", country)
                .limit(10)

            first.get().then((documentSnapshots) => {
                dispatch({ type: 'GET_USERS', payload: { data: documentSnapshots.docs.map(doc => doc.data()), first: documentSnapshots.docs[documentSnapshots.docs.length=0], last: documentSnapshots.docs[documentSnapshots.docs.length-1]} });
            })
            .catch(error => dispatch({ type: 'GET_USERS_ERROR', payload: { code: 'users/error', message: error } }))   
        }
    }

    const getUsersPerMonth = async (startActualDate, endActualDate, startPreviusDate, endPreviusDate) => {
        dispatch({ type: 'GET_USERS_BY_ID_LOADING' });

        let db = firestoreInitialize();

        let usersActualMonth;
        let usersPreviusMonth;

        let convertActualDate = new Date(startActualDate).getTime();
        convertActualDate = convertActualDate + 86400000;
        convertActualDate = new Date(convertActualDate).setHours(0);

        let convertDate = new Date(convertActualDate);
        let startDate = new Date(convertDate.getFullYear(), convertDate.getMonth(), 1);
        let endDate = new Date(convertDate.getFullYear(), convertDate.getMonth() + 1, 0);
        endDate = endDate.setHours(23,59,59,999)

        await db.collection('Administradores')
        .where('createdAt', '>=', new Date(startDate))
        .where('createdAt', '<=', new Date(endDate))
        .get()
        .then((documentSnapshots) => {
            usersActualMonth = documentSnapshots.docs.map(doc => doc.data())
        })

        if (startPreviusDate !== 0 && endPreviusDate !== 0) {
            let convertActualStartDate = new Date(startPreviusDate).getTime();
            convertActualStartDate = convertActualStartDate + 86400000;
            convertActualStartDate = new Date(convertActualStartDate).setHours(0);

            let convertDate = new Date(convertActualStartDate);
            let startDate = new Date(convertDate.getFullYear(), convertDate.getMonth(), 1);
            let endDate = new Date(convertDate.getFullYear(), convertDate.getMonth() + 1, 0);
            endDate = endDate.setHours(23,59,59,999)

            await db.collection('Administradores')
            .where('createdAt', '>=', new Date(startDate))
            .where('createdAt', '<=', new Date(endDate))
            .get()
            .then((documentSnapshots) => {
                usersPreviusMonth = documentSnapshots.docs.map(doc => doc.data())
            })

            dispatch({ type: 'GET_USERS_BY_ID', payload: { usersActualMonth: usersActualMonth, usersPreviusMonth: usersPreviusMonth } })
        } else {
            dispatch({ type: 'GET_USERS_BY_ID', payload: { usersActualMonth: usersActualMonth, usersPreviusMonth: [] } })
        }
    };

    const getUsersAllMonth = async (year) => {
        dispatch({ type: 'GET_USERS_LOADING' });

        let db = firestoreInitialize();

        let usersPerMonth = [];

        for (let index = 1; index <= 12; index++) {
            let month;

            if (index < 10) {
                month = `0${index.toString()}`;
            } else {
                month = `${index.toString()}`;
            }

            let convertDateStart = new Date(`${year}-${month}-01`).setHours(0)

            let convertDate = new Date(convertDateStart);

            let startDate;
            let endDate;

            if (index === 1) {
                startDate = new Date(convertDate.getFullYear() + 1, convertDate.getMonth(), 1);
                endDate = new Date(convertDate.getFullYear() + 1, convertDate.getMonth() + 1, 0);
            } else {
                startDate = new Date(convertDate.getFullYear(), convertDate.getMonth(), 1);
                endDate = new Date(convertDate.getFullYear(), convertDate.getMonth() + 1, 0);
            }

            endDate = endDate.setHours(23,59,59,999)

            await db.collection('Administradores')
            .where('createdAt', '>=', new Date(startDate))
            .where('createdAt', '<=', new Date(endDate))
            .get()
            .then((documentSnapshots) => {
                usersPerMonth.push(documentSnapshots.docs.map(doc => doc.data()))
            })
        }

        dispatch({ type: 'GET_USERS', payload: { data: usersPerMonth, first: null, last: null } });
    };

    const getUsersById = (id) => {
        dispatch({ type: 'GET_USERS_BY_ID_LOADING' });

        let db = firestoreInitialize();

        let docRef = db.collection("Administradores").doc(id);

        docRef.get().then((doc) => {
            if (doc.exists) {
                dispatch({ type: 'GET_USERS_BY_ID', payload: doc.data() })
            } else {
                dispatch({ type: 'GET_USERS_BY_ID', payload: null })
            }
        }).catch((error) => {
            dispatch({ type: 'GET_USERS_BY_ID_ERROR', payload: { code: 'user/user-error', message: error } })
        });
    };

    const createUserWithEmailAndPassword = (firstName, lastName, email, role, password, country, countryFlag) => {
        dispatch({ type: 'CREATE_USER_LOADING' })

        let authInstance = getFirebaseApp('auth-worker');
        let authInstanceWorker = firebase.auth(authInstance);
        authInstanceWorker.setPersistence(firebase.auth.Auth.Persistence.NONE);

        authInstanceWorker.createUserWithEmailAndPassword(email, password)
            .then((userData) => completeDataWithCreateUser(userData, firstName, lastName, email, role, country, countryFlag))
            .catch((error) => completeEmailWithCreateUser(firstName, lastName, email, role, country, countryFlag, error));
    };

    const completeDataWithCreateUser = (userData, firstName, lastName, email, role, country, countryFlag) => {        
        let db = firestoreInitialize();

        let date = firebase.firestore.FieldValue.serverTimestamp();

        db.collection("Administradores").doc(userData.user.uid).set({
            authId: userData.user.uid,
            administradorId: userData.user.uid,
            nombre: firstName,
            apellido: lastName,
            email: email,
            status: true,
            role: role,
            pais: country,
            codigoPais: countryFlag,
            createdAt: date
        })
        .then(() => {
            dispatch({ type: 'CREATE_USER', payload: { userFirstName: firstName, userLastName: lastName, userEmail: email, userStatus: true, userRole: role, userIsCreated: false } })
        })
        .catch((error) => {
            dispatch({ type: 'CREATE_USER_ERROR', payload: { code: 'new-user/error', message: error } })
        });
    };

    const completeEmailWithCreateUser = (firstName, lastName, email, role, country, countryFlag, errorEmailExists) => {
        let db = firestoreInitialize();

        let date = firebase.firestore.FieldValue.serverTimestamp();

        db.collection("Administradores").where("email", "==", email).get().then((querySnapshot) => {
            const emailExists = querySnapshot.docs.map(doc => doc.data());

            if (emailExists.length > 0) {
                dispatch({ type: 'CREATE_USER_ERROR', payload: errorEmailExists })
            } else {
                db.collection("Administradores").add({
                    authId: "",
                    nombre: firstName,
                    apellido: lastName,
                    email: email,
                    status: true,
                    role: role,
                    country: country,
                    codigoPais: countryFlag,
                    createdAt: date
                })
                .then((doc) => {
                    db.collection("Administradores").doc(doc.id).update({
                        administradorId: doc.id
                    })
                    .then(() => {
                        dispatch({ type: 'CREATE_USER', payload: { userFirstName: firstName, userLastName: lastName, userEmail: email, userStatus: true, userRole: role, userIsCreated: true } })
                    })
                })
            }
        })
        .catch((error) => {
            dispatch({ type: 'CREATE_USER_ERROR', payload: { code: 'new-user/error', message: error } })
        });
    };

    const updateUsersById = (id, firstName, lastName, role, status, country, countryFlag) => {
        dispatch({ type: 'UPDATE_USERS_BY_ID_LOADING' });
        
        let db = firestoreInitialize();

        let docRef = db.collection("Administradores").doc(id);

        docRef.update({
            nombre: firstName,
            apellido: lastName,
            status: status,
            role: role,
            pais: country,
            codigoPais: countryFlag
        })
        .then(() => {
            dispatch({ type: 'UPDATE_USERS_BY_ID', payload: { 
                newFirstName: firstName,
                newLastName: lastName,
                newStatus: status,
                newRole: role,
                newCountry: country,
                newCodeCountry: countryFlag
            }});
        })
        .catch((error) => {
            dispatch({ type: 'UPDATE_USERS_BY_ID_ERROR', payload: { code: 'user/update-error', message: error } });
        });
    };

    const updateUserPassword = (password, newPassword) => {
        dispatch({ type: 'UPDATE_USER_PASSWORD_LOADING' });

        const user = firebase.auth().currentUser;
        const credential = firebase.auth.EmailAuthProvider.credential(user.email, password);

        user.reauthenticateWithCredential(credential).then(() => {
            user.updatePassword(newPassword).then(() => {
                dispatch({ type: 'UPDATE_USER_PASSWORD' })
            }).catch((error) => {
                dispatch({ type: 'UPDATE_USER_PASSWORD_ERROR', payload: { code: 'password/update-error', message: error } })
            });
        }).catch((error) => {
            dispatch({ type: 'UPDATE_USER_PASSWORD_ERROR', payload: { code: error.code, message: error.message } })
        });
    };

    const updateUserAvatar = (id, data) => {
        dispatch({ type: 'UPDATE_USER_AVATAR_LOADING' });

        let db = firestoreInitialize();
        const storage = firebase.storage();

        if (data.avatar) {
            let storageRef = storage.ref();

            const metadata = {
                contentType: 'image/jpeg',
            };

            let uploadTask = storageRef.child(`Configuraciones/Avatar/${data.avatar.name}`).put(data.avatar, metadata);

            uploadTask.on('state_changed', function() {
                }, function(error) {
                    dispatch({ type: 'UPDATE_USER_AVATAR_ERROR', payload: { code: 'avatar/update-error', message: error } });
                }, function() {
                uploadTask.snapshot.ref.getDownloadURL().then(function(downloadURL) {
                    db.collection('Administradores').doc(id).update({
                        avatar: downloadURL
                    })
                    .then(() => {
                        dispatch({ type: "UPDATE_USER_AVATAR" })
                    })
                    .catch((error) => dispatch({ type: 'UPDATE_USER_AVATAR_ERROR', payload: { code: 'avatar/error', message: error } }))
                });
            });
        } else {
            if (data.deleteAvatar && data.avatarPath.length > 0) {
                let storageRef = storage.refFromURL(data.avatarPath);

                storageRef.delete().then(function() {
                    db.collection('Administradores').doc(id).update({
                        avatar: ""
                    })
                    .then(() => {
                        dispatch({ type: "UPDATE_USER_AVATAR" })
                    })
                    .catch((error) => dispatch({ type: 'UPDATE_USER_AVATAR_ERROR', payload: { code: 'avatar/error', message: error } }))
                }).catch(function(error) {
                    dispatch({ type: 'UPDATE_USER_AVATAR_ERROR', payload: { code: 'avatar/update-error', message: error } });
                });
            } else {
                db.collection('Administradores').doc(id).update({
                    avatar: data.avatarPath
                })
                .then(() => {
                    dispatch({ type: "UPDATE_USER_AVATAR" })
                })
                .catch((error) => dispatch({ type: 'UPDATE_USER_AVATAR_ERROR', payload: { code: 'avatar/error', message: error } }))
            }
        }
    };

    const usersResetState = () => {
        dispatch({ type: 'USERS_RESET_STATE' });
    }

    return (
        <UsersContext.Provider value={{
            usersState: state.getUsers,
            usersByIdState: state.getUsersById,
            createUserState: state.createUser,
            updateUsersByIdState: state.updateUsersById,
            updateUserPasswordState: state.updateUserPassword,
            updateUserAvatarState: state.updateUserAvatar,
            getUsers,
            getUsersPerMonth,
            getUsersAllMonth,
            getUsersById,
            createUserWithEmailAndPassword,
            updateUsersById,
            updateUserPassword,
            updateUserAvatar,
            usersResetState
        }}>
            {props.children}
        </UsersContext.Provider>
    )
}

export default UsersState;
